import { render, staticRenderFns } from "./OrderCompensate.vue?vue&type=template&id=59f120fa&scoped=true&"
import script from "./OrderCompensate.vue?vue&type=script&lang=js&"
export * from "./OrderCompensate.vue?vue&type=script&lang=js&"
import style0 from "./OrderCompensate.vue?vue&type=style&index=0&id=59f120fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f120fa",
  null
  
)

export default component.exports